"use client";

import { Link } from "@/components/common/Link";
import { useState, useEffect } from 'react';
const HEAD = {
  fontFamily: "'Manrope', sans-serif"
};
const LABEL = {
  fontFamily: "'Manrope', sans-serif"
};
const serviceLinks = [{
  label: "Garage Door Repair",
  href: "/garage-door-repair-sydney/"
}, {
  label: "Garage Door Installation",
  href: "/garage-door-installation-sydney/"
}, {
  label: "Emergency Repair (24/7)",
  href: "/emergency-garage-door-repair/"
}, {
  label: "Opener & Motor Repair",
  href: "/opener-repair-installation/"
}, {
  label: "Spring Replacement",
  href: "/spring-repair/"
}, {
  label: "Roller Door Service",
  href: "/roller-door-service/"
}];
const areaList = ["Eastern Suburbs", "North Shore", "Inner West", "Hills District", "Western Sydney", "Sutherland Shire", "Northern Beaches", "Sydney CBD"];
const companyLinks = [{
  label: "Our Services",
  href: "#servicesshowcase"
}, {
  label: "Service Areas",
  href: "#serviceareas"
}, {
  label: "FAQs",
  href: "#faq"
}, {
  label: "Gallery",
  href: "/gallery/"
}, {
  label: "Contact",
  href: "/contact/"
}];
const navyBg = "[background-image:radial-gradient(rgba(255,255,255,0.045)_1px,transparent_1px),linear-gradient(160deg,#081438_0%,#0d1e3a_100%)] [background-size:18px_18px,100%_100%]";
export default function SiteFooter() {
  const [year, setYear] = useState<number | null>(null);
  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);
  return <>
      <footer style={HEAD} className={`relative w-full ${navyBg} text-white overflow-hidden`}>
        {}
        <div className="absolute top-0 inset-x-0 h-[2px]" style={{
        background: "linear-gradient(to right, transparent, #F5A623, transparent)"
      }} />
        {}
        <div className="absolute -top-24 right-[8%] w-72 h-72 rounded-lg bg-[#F5A623]/[0.05] pointer-events-none" />

        <div className="relative max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-16">
          <div className="grid gap-10 md:gap-8 md:grid-cols-12">

            {}
            <div className="md:col-span-4">
              <div className="flex items-center gap-2.5 mb-4">
                <span className="flex size-9 items-center justify-center">
                  <img src="https://equipped-bass.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-Nov-13-2025-at-12_22_05-PM-copy-1.webp" alt="Gold Garage Door Logo" className="size-9 object-contain" loading="lazy" />
                </span>
                <span style={HEAD} className="text-[19px] font-extrabold tracking-tight text-white leading-none">
                  GOLD GARAGE DOOR
                </span>
              </div>

              <p style={HEAD} className="text-white/55 text-[14px] leading-relaxed max-w-sm mb-6">
                Sydney's trusted garage door specialists — repairs, installations and 24/7 emergency service across every suburb. Honest fixed-price quotes, premium parts, guaranteed workmanship.
              </p>

              <ul className="space-y-3">
                <li>
                  <Link to="tel:0485000933" aria-label="Call 0485 000 933" style={HEAD} className="group flex items-center gap-3 text-white/80 hover:text-white transition-colors no-underline">
                    <span className="flex size-9 items-center justify-center rounded-lg bg-white/6 border border-white/10 group-hover:border-[#F5A623]/50 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[16px] text-[#F5A623]" aria-hidden="true" focusable="false"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                    </span>
                    <span className="text-[14px] font-semibold">0485 000 933</span>
                  </Link>
                </li>
                <li>
                  <Link to="https://wa.me/61485000933" aria-label="WhatsApp us" style={HEAD} className="group flex items-center gap-3 text-white/80 hover:text-white transition-colors no-underline">
                    <span className="flex size-9 items-center justify-center rounded-lg bg-white/6 border border-white/10 group-hover:border-[#F5A623]/50 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[16px] text-[#F5A623]" aria-hidden="true" focusable="false"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /></svg>
                    </span>
                    <span className="text-[14px] font-semibold">WhatsApp Us</span>
                  </Link>
                </li>
                <li>
                  <Link to="mailto:goldgaragedoor1@gmail.com" style={HEAD} className="group flex items-center gap-3 text-white/80 hover:text-white transition-colors no-underline">
                    <span className="flex size-9 items-center justify-center rounded-lg bg-white/6 border border-white/10 group-hover:border-[#F5A623]/50 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[16px] text-[#F5A623]" aria-hidden="true" focusable="false"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                    </span>
                    <span className="text-[14px] font-semibold break-all">goldgaragedoorau@gmail.com</span>
                  </Link>
                </li>
                <li className="flex items-center gap-3 text-white/80">
                  <span className="flex size-9 items-center justify-center rounded-lg bg-white/6 border border-white/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[16px] text-[#F5A623]" aria-hidden="true" focusable="false"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
                  </span>
                  <span style={HEAD} className="text-[14px] font-semibold">All Around Sydney NSW</span>
                </li>
                <li className="flex items-center gap-3 text-white/80">
                  <span className="flex size-9 items-center justify-center rounded-lg bg-white/6 border border-white/10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-[16px] text-[#F5A623]" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                  </span>
                  <span style={HEAD} className="text-[14px] font-semibold">Open 24/7 · Same-Day Service</span>
                </li>
              </ul>
            </div>

            {}
            <div className="md:col-span-3">
              <h3 style={LABEL} className="text-[12px] font-bold uppercase tracking-[0.16em] text-[#F5A623] mb-4">Services</h3>
              <ul className="space-y-2.5">
                {serviceLinks.map((s, i) => <li key={s.label} data-index={i}>
                    <Link to={s.href} style={HEAD} className="group inline-flex items-center gap-1.5 text-white/65 hover:text-white text-[14px] font-medium transition-colors no-underline">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-3.5 text-[#F5A623]/0 group-hover:text-[#F5A623] -ml-1 transition-colors" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6" /></svg>
                      {s.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div className="md:col-span-3">
              <h3 style={LABEL} className="text-[12px] font-bold uppercase tracking-[0.16em] text-[#F5A623] mb-4">Service Areas</h3>
              <ul className="space-y-2.5 mb-3">
                {areaList.map((a, i) => <li key={a} data-index={i} style={HEAD} className="text-white/65 text-[14px] font-medium">{a}</li>)}
              </ul>
              <Link to="#serviceareas" style={LABEL} className="inline-flex items-center gap-1.5 text-[#F5A623] text-[13px] font-bold hover:gap-2.5 transition-all no-underline">
                View all 150+ suburbs <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-3.5" aria-hidden="true" focusable="false"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
              </Link>
            </div>

            {}
            <div className="md:col-span-2">
              <h3 style={LABEL} className="text-[12px] font-bold uppercase tracking-[0.16em] text-[#F5A623] mb-4">Company</h3>
              <ul className="space-y-2.5 mb-6">
                {companyLinks.map((c, i) => <li key={c.label} data-index={i}>
                    <Link to={c.href} style={HEAD} className="text-white/65 hover:text-white text-[14px] font-medium transition-colors no-underline">
                      {c.label}
                    </Link>
                  </li>)}
              </ul>

              <Link to="#contact-us" style={LABEL} className="flex items-center justify-center gap-2 bg-[#F5A623] text-[#081438] font-bold text-[13px] px-4 py-3 rounded-xl shadow-lg shadow-[#F5A623]/20 hover:bg-[#d4a017] hover:-translate-y-0.5 transition-all no-underline">
                Get Free Quote <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-4" aria-hidden="true" focusable="false"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
              </Link>
            </div>
          </div>

          {}
          <div className="mt-12 pt-7 border-t border-white/10 flex flex-wrap items-center gap-x-7 gap-y-3">
            <span className="inline-flex items-center gap-2 text-white/70 text-[13px] font-semibold" style={LABEL}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-4 text-[#F5A623]" aria-hidden="true" focusable="false"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" /></svg> NSW Fair Trading Licensed
            </span>
            <span className="inline-flex items-center gap-2 text-white/70 text-[13px] font-semibold" style={LABEL}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-4 text-[#F5A623]" aria-hidden="true" focusable="false"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /><path d="m9 12 2 2 4-4" /></svg> Fully Insured Technicians
            </span>
            <span className="inline-flex items-center gap-2 text-white/70 text-[13px] font-semibold" style={LABEL}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="size-4 text-[#F5A623] fill-[#F5A623]" aria-hidden="true" focusable="false" data-ast-id="f:/src/pages/HomePageGoldGarageDoor/sections/BrandFooter.tsx|sig:h2z64n" data-ast-start="12101" data-ast-end="12486"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-ast-id="f:/src/pages/HomePageGoldGarageDoor/sections/BrandFooter.tsx|sig:1xfoyq" data-ast-start="12365" data-ast-end="12480"></polygon></svg> 5.0 · 300+ Google Reviews</span>
          </div>

          {}
          <div className="mt-7 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <p style={LABEL} className="text-white/45 text-[12.5px]">© {year || new Date().getFullYear()} Gold Garage Door. All rights reserved. · ABN 48382981929</p>
            <div className="flex items-center gap-5">
              <Link to="#" style={LABEL} className="text-white/45 hover:text-white/80 text-[12.5px] transition-colors no-underline">Privacy Policy</Link>
              <Link to="#" style={LABEL} className="text-white/45 hover:text-white/80 text-[12.5px] transition-colors no-underline">Terms</Link>
              <span style={LABEL} className="text-white/45 text-[12.5px]">Servicing all Sydney suburbs</span>
            </div>
          </div>
        </div>
      </footer>
    </>;
}